import { render, staticRenderFns } from "./ContentChains.vue?vue&type=template&id=a6f45d1c&"
import script from "./ContentChains.vue?vue&type=script&lang=js&"
export * from "./ContentChains.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports